var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MovementList',{key:_vm.scopeId,attrs:{"scope-type":_vm.scopeType,"scope-id":_vm.scopeId}})}
var staticRenderFns = []

export { render, staticRenderFns }